import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [formError, setFormError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const { login, error: authError } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get redirect path from location state or default to home
  const from = location.state?.from || '/';

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      setFormError('Please enter both email and password');
      return;
    }
    setIsSubmitting(true);
    setFormError('');
    try {
      const user = await login(email, password);
      if (user && (user.isAdmin || user.is_admin || user.role === 'admin')) {
        navigate('/admin', { replace: true });
      } else {
        navigate(from, { replace: true });
      }
    } catch (error) {
      setIsSubmitting(false);
    }
  };

  return (
    <div style={{
      minHeight: 'calc(100vh - 80px)',
      background: 'linear-gradient(103.95deg, rgb(227, 238, 255) -0.02%, rgb(252, 213, 229) 99.98%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <div style={{
        background: 'white',
        borderRadius: '2rem',
        boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.18)',
        padding: '2.5rem 2rem',
        width: '100%',
        maxWidth: 420,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}>
        {/* Logo */}
        <div style={{ marginBottom: 16 }}>
          <img src="/app-logo.png" alt="app logo" style={{ height: '42px', width: '42px', marginRight: '8px' }} />
        </div>
        <div style={{ marginBottom: 2, fontWeight: 500, fontSize: 18, color: '#1e3c72' }}>Welcome to Telering Process Pvt. Ltd</div>
        <div style={{ marginBottom: 16, color: '#4f46e5', fontSize: 14, fontWeight: 500, textAlign: 'center' }}>
          Empowering your workspace with ergonomic furniture and high-performance office essentials.
        </div>
        {(formError || authError) && (
          <div style={{ color: '#e53e3e', background: '#fff0f0', borderRadius: 8, padding: '8px 12px', marginBottom: 16, width: '100%', textAlign: 'center', fontSize: 14 }}>
            {formError || authError}
          </div>
        )}
        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
          <div style={{ marginBottom: 18 }}>
            <label style={{ fontSize: 14, color: '#222', fontWeight: 500 }}>Email</label>
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              disabled={isSubmitting}
              style={{
                width: '100%',
                padding: '10px 12px',
                border: '1.5px solid #4f46e5',
                borderRadius: 8,
                marginTop: 4,
                fontSize: 15,
                outline: 'none',
                transition: 'border 0.2s',
                background: '#f8fafc',
              }}
              onFocus={e => e.target.style.border = '1.5px solid #3730a3'}
              onBlur={e => e.target.style.border = '1.5px solid #4f46e5'}
            />
          </div>
          <div style={{ marginBottom: 8, position: 'relative' }}>
            <label style={{ fontSize: 14, color: '#222', fontWeight: 500 }}>Password</label>
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder="Password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              disabled={isSubmitting}
              style={{
                width: '100%',
                padding: '10px 38px 10px 12px',
                border: '1.5px solid #4f46e5',
                borderRadius: 8,
                marginTop: 4,
                fontSize: 15,
                outline: 'none',
                background: '#f8fafc',
                transition: 'border 0.2s',
              }}
              onFocus={e => e.target.style.border = '1.5px solid #3730a3'}
              onBlur={e => e.target.style.border = '1.5px solid #4f46e5'}
            />
            <span
              onClick={() => setShowPassword(s => !s)}
              style={{
                position: 'absolute',
                right: 12,
                top: 36,
                cursor: 'pointer',
                color: '#888',
                fontSize: 18,
              }}
              tabIndex={0}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>
          <button
            type="submit"
            disabled={isSubmitting}
            style={{
              width: '100%',
              background: '#4f46e5',
              color: 'white',
              border: 'none',
              borderRadius: 8,
              padding: '12px 0',
              fontWeight: 600,
              fontSize: 16,
              boxShadow: '0 2px 8px 0 rgba(31, 38, 135, 0.10)',
              marginTop: 16,
              cursor: isSubmitting ? 'not-allowed' : 'pointer',
              transition: 'background 0.2s',
            }}
          >
            {isSubmitting ? 'Logging in...' : 'Login'}
          </button>
        </form>
        <div style={{ marginTop: 24, fontSize: 15, color: '#222', textAlign: 'center' }}>
          Don't have an account? {' '}
          <Link to="/register" style={{ color: '#4f46e5', fontWeight: 500, textDecoration: 'none' }}>
            Create an account
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LoginPage; 